import React, { useEffect, useRef, useState } from 'react';

interface getTrackConfigArgs {
  error?: boolean;
  source: {
    value: number;
    percent: number;
  };
  target: {
    value: number;
    percent: number;
  };
  disabled?: boolean;
  styles?: {
    error: object;
    valid: object;
  };
}

const getTrackConfig = ({ error, source, target, disabled, styles }: getTrackConfigArgs) => {
  const basicStyle = {
    left: `${source.percent}%`,
    width: `calc(${target.percent - source.percent}% - 1px)`,
  };

  if (disabled) return basicStyle;

  const coloredTrackStyle = error
    ? {
        backgroundColor: 'rgba(214,0,11,0.5)',
        borderLeft: '1px solid rgba(214,0,11,0.5)',
        borderRight: '1px solid rgba(214,0,11,0.5)',
      }
    : {
        backgroundColor: 'rgba(98, 203, 102, 0.5)',
        borderLeft: '1px solid #62CB66',
        borderRight: '1px solid #62CB66',
      };

  if (styles) {
    if (error) {
      return { ...basicStyle, ...styles.error };
    } else {
      return { ...basicStyle, ...styles.valid };
    }
  }

  return { ...basicStyle, ...coloredTrackStyle };
};

interface TrackProps {
  error?: boolean;
  source: {
    value: number;
    percent: number;
  };
  target: {
    value: number;
    percent: number;
  };
  getTrackProps: () => object;
  disabled?: boolean;
  styles?: {
    error: object;
    valid: object;
  };
  onClick?: () => void;
  image?: string;
  attendees?: number;
  blocked?: boolean;
}

const Track: React.FC<TrackProps> = ({
  error,
  source,
  target,
  getTrackProps,
  disabled = false,
  blocked = false, // To not allow booking the past
  styles = {
    error: {
      backgroundColor: 'rgba(214,0,11,0.5)',
      borderLeft: '1px solid rgba(214,0,11,0.5)',
      borderRight: '1px solid rgba(214,0,11,0.5)',
    },
    valid: {
      backgroundColor: 'rgba(98, 203, 102, 0.5)',
      borderLeft: '1px solid #62CB66',
      borderRight: '1px solid #62CB66',
    },
  },
  onClick,
  image,
  attendees
}) => {
  const imgRef = useRef(null);
  const containerRef = useRef(null);
  const [showImage, setShowImage] = useState(true);

  useEffect(() => {
    const container = containerRef?.current;
    const img = imgRef?.current;

    if (container && img) {
      const onLoad = () => {
        const containerWidth = container.clientWidth;
        const contentWidth = img.clientWidth;
        setShowImage(contentWidth <= containerWidth); // borders
      };

      if (img.complete) {
        onLoad();
      } else {
        img.addEventListener('load', onLoad);
        return () => img.removeEventListener('load', onLoad);
      }
    }
  }, []);
  
  return (
    <div
      className={`react_time_range__track${blocked ? '__blocked' : disabled ? '__disabled z-40' : ''}`}
      style={getTrackConfig({ error, source, target, disabled, styles })}
      {...(!disabled ? getTrackProps() : {})}
      onClick={onClick}
      ref={containerRef}
    >

      {disabled && !blocked ? (
        <div className='disabled_interval_image_container flex flex-col overflow-hidden m-2'>
          {showImage && (
            <div className='flex flex-col'>
              <div className='image-container'>
                <img ref={imgRef} src={image} className="object-cover w-full h-full"/>
              </div>
              {attendees > 1 ? <h4>and {attendees} others</h4> : null}  
            </div>
          )}
        </div>
      ) : null}

    </div>
  )
};

export default Track;
